import axios from "axios";

export const billing = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  timeout: 30000,
});

billing.interceptors.request.use((config) => {
  const t = localStorage.getItem("whoonow_access");
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});
